import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import { checkIfProductIsGift } from '~/helpers/checkIfProductIsGift';
import { generateVariantString } from '~/utils';
import { sortProductsWithDiscountProperty } from '~/helpers/sortProductsWithDiscountProperty';
import { useLocalization } from '~/composables/_next/useLocalization';
export function useCartPreviewHelpers(products) {
  var filterProducts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  var parsedProducts = computed(function () {
    var _products$map$sort;
    var mappedProducts = (_products$map$sort = products.map(function (product) {
      var _product$price, _product$price$value, _product$variant$imag, _product$custom, _product$custom$custo, _product$custom$custo2;
      var normalPriceCentAmount = (_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$value = _product$price.value) === null || _product$price$value === void 0 ? void 0 : _product$price$value.centAmount;
      var getPrice = function getPrice() {
        var _product$price2, _product$price2$disco, _product$price3, _product$price3$disco;
        if ((_product$price2 = product.price) !== null && _product$price2 !== void 0 && (_product$price2$disco = _product$price2.discounted) !== null && _product$price2$disco !== void 0 && _product$price2$disco.discount && (_product$price3 = product.price) !== null && _product$price3 !== void 0 && (_product$price3$disco = _product$price3.discounted) !== null && _product$price3$disco !== void 0 && _product$price3$disco.value) {
          // get price with discount
          return {
            regular: product.price.value.centAmount / 100,
            special: product.price.discounted.value.centAmount / 100
          };
        }

        // get price without discount
        return {
          regular: product.price.value.centAmount / 100,
          special: null
        };
      };
      var getDiscount = function getDiscount() {
        var _product$price$discou;
        var isGift = false;
        var requiresCode = null;
        var productGiftInfo = checkIfProductIsGift(product);
        if (productGiftInfo) {
          isGift = true;
          requiresCode = productGiftInfo.requiresCode;
        }
        var discountedCentAmount = (_product$price$discou = product.price.discounted) === null || _product$price$discou === void 0 ? void 0 : _product$price$discou.value.centAmount;
        return {
          isGift: isGift,
          requiresCode: requiresCode,
          discountedCentAmount: discountedCentAmount,
          price: discountedCentAmount / 100,
          percentage: calculateDiscountPercentage(discountedCentAmount / 100, normalPriceCentAmount / 100)
        };
      };
      return {
        name: product.name,
        normalPrice: normalPriceCentAmount / 100,
        price: getPrice(),
        discount: getDiscount(),
        sku: product.variant.sku,
        image: (_product$variant$imag = product.variant.images[0]) === null || _product$variant$imag === void 0 ? void 0 : _product$variant$imag.url,
        images: product.variant.images,
        quantity: product.quantity,
        variantString: generateVariantString(product.variant, locale),
        addedAt: product.addedAt,
        startsOn: (_product$custom = product.custom) === null || _product$custom === void 0 ? void 0 : (_product$custom$custo = _product$custom.customFieldsRaw) === null || _product$custom$custo === void 0 ? void 0 : (_product$custom$custo2 = _product$custom$custo[2]) === null || _product$custom$custo2 === void 0 ? void 0 : _product$custom$custo2.value,
        slug: product.productSlug
      };
    }).sort(sortProductsWithDiscountProperty)) !== null && _products$map$sort !== void 0 ? _products$map$sort : [];
    return filterProducts ? mappedProducts.filter(function (product) {
      return product.discount.isGift ? !product.discount.requiresCode : true;
    }) : mappedProducts;
  });
  var productsAmount = computed(function () {
    var _parsedProducts$value, _parsedProducts$value2;
    var productsWithoutGifts = (_parsedProducts$value = parsedProducts.value) === null || _parsedProducts$value === void 0 ? void 0 : _parsedProducts$value.filter(function (product) {
      return !product.discount || product.discount && !product.discount.isGift;
    });
    var productsWithGifts = (_parsedProducts$value2 = parsedProducts.value) === null || _parsedProducts$value2 === void 0 ? void 0 : _parsedProducts$value2.filter(function (product) {
      var _product$discount;
      return (_product$discount = product.discount) === null || _product$discount === void 0 ? void 0 : _product$discount.isGift;
    });
    var productsWithoutGiftsQuantity = productsWithoutGifts.map(function (product) {
      return product.quantity || 0;
    });
    return {
      productsAmount: productsWithoutGifts.length === 1 ? productsWithoutGifts[0].quantity : productsWithoutGifts.length,
      giftsAmount: productsWithGifts.length,
      productsAmountWithQuantity: productsWithoutGifts.length === 1 ? productsWithoutGifts[0].quantity : productsWithoutGiftsQuantity.length ? productsWithoutGiftsQuantity.reduce(function (total, quantity) {
        return total + quantity;
      }) : 0
    };
  });
  return {
    parsedProducts: parsedProducts,
    productsAmount: productsAmount
  };
}
function calculateDiscountPercentage(discountPrice, normalPrice) {
  if (!discountPrice) {
    return '0';
  }
  var diff = normalPrice - discountPrice;
  return (diff / normalPrice * 100).toFixed(0);
}